/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import moment from 'moment';
import { OPERATOR_ID } from '../configs/const';
import { allowTwoDecimal } from '../util/numeric.util';
import * as affiliateService from '../services/affiliateService'
class AffiliateRequestTr extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         sharing: 0,
         affiliateCode: '',
         buttonDisable: false
      };
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }

   onChangeCode(e) {
      const name = e.target.name;
      let value = e.target.value;
      value = value.replace(/[^a-zA-Z0-9]/g, '');
      value = value.toUpperCase();
      this.setState({ [name]: value })
   }


   componentDidMount() {
      // this.componentDidMountTask();
   }
   onSubmitClick(Status) {
      const self = this;
      if (Status === 'APPROVED' && (!(!!this.state.affiliateCode) || this.state.affiliateCode.length < 8)) {
         this.props.notify("Affiliate Code must have atleast 8 characters!", "error");
         return false;
      }
      let params = {
         "username": this.props.usr.username,
         "affiliateCode": this.state.affiliateCode,
         "isActive": true,
         "sharing": this.state.sharing,
         "status": Status
      }
      this.setState({ buttonDisable: true},()=>{
         affiliateService.approvedAffiliateRequest(params).then(async (result) => {
            if (!!result) {
               if (!!result.isSuccess) {
                  self.props.notify('submited successfully.', "success");
                  self.props.removeAffiliateRequestRow(this.props.usr);
               } else {
                  self.props.notify(result.exception.message, "error");
               }
            }
            self.setState({ buttonDisable: false});
         }).catch(error => {
            self.setState({ buttonDisable: false});
         });
      })

   }
   onRejectClick() {

   }

   render() {

      return (
         <>
            <tr>
               <td><span>{this.props.usr.username}</span></td>
               <td><span>{this.props.usr.name}</span></td>
               <td><span>{this.props.usr.mobile}</span></td>
               <td><span>{!!this.props.usr.parentId ? this.props.usr.parentId : ''}</span></td>
               <td><span>{!!this.props.usr.website ? this.props.usr.website : ''}</span></td>
               <td><span>{!!this.props.usr.applicationNumber ? this.props.usr.applicationNumber : ''}</span></td>
               <td><span>{!!this.props.usr.createdDate ? moment(this.props.usr.createdDate).format('DD/MM/YYYY HH:mm:ss') : ''}</span></td>
               <td>
                  <input className='w-100' type='number' name='sharing' value={this.state.sharing} onChange={(e) => this.onChange(e)} onKeyDown={(e) => allowTwoDecimal(e)} />
               </td>
               <td>
                  <input className='w-100' type='text' name='affiliateCode' value={this.state.affiliateCode} onChange={(e) => this.onChangeCode(e)} />
               </td>
               <td>
                  <button className='btn btn-blue btn-sm' disabled={this.state.buttonDisable} onClick={() => this.onSubmitClick("APPROVED")}>Submit</button>
                  <button className='btn btn-danger btn-sm ml-1' disabled={this.state.buttonDisable} onClick={() => this.onSubmitClick("REJECTED")}>Reject</button>
               </td>
            </tr>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateRequestTr);